// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pose3d-media-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(10, 132, 255, 0.08);
  border: 1px solid rgba(10, 132, 255, 0.25);
}

.pose3d-media-toolbar__btn {
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  font-weight: 600;
  cursor: pointer;
  background: #0a84ff;
  color: #fff;
}

.pose3d-media-toolbar__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pose3d-media-toolbar__btn--secondary {
  background: transparent;
  color: #0a84ff;
  border: 1px solid rgba(10, 132, 255, 0.45);
}

.player-exercise-details__eval-video-card--pose3d-selected {
  outline: 2px solid #0a84ff;
  outline-offset: 1px;
}

.player-exercise-details__move-video-icon-btn--active {
  background: rgba(10, 132, 255, 0.18) !important;
  color: #0a84ff;
}

.pose3d-setup {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 420px;
}

.pose3d-setup__cams {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

@media (max-width: 900px) {
  .pose3d-setup__cams {
    grid-template-columns: 1fr;
  }
}

.pose3d-setup__cam {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 8px;
  background: #0f1114;
  color: #fff;
}

.pose3d-setup__cam h4 {
  margin: 0 0 8px;
  font-size: 14px;
}

.pose3d-setup__video-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  overflow: hidden;
  border-radius: 4px;
  touch-action: none;
}

.pose3d-setup__video-wrap video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.pose3d-setup__overlay {
  /* Position/size set in JS to match object-fit:contain letterbox. */
  position: absolute;
  cursor: crosshair;
  z-index: 2;
  touch-action: none;
}

.pose3d-setup__controls {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 8px;
  font-size: 13px;
}

.pose3d-setup__controls input[type="number"] {
  width: 72px;
}

.pose3d-setup__shared {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  padding: 8px 0;
}

.pose3d-setup__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.pose3d-setup__status {
  font-size: 13px;
  opacity: 0.85;
}

.pose3d-setup__error {
  color: #ff6b6b;
  font-size: 13px;
}

.pose3d-web-viewer__canvas {
  width: 100%;
  height: min(56vh, 480px);
  background: #111;
  border-radius: 8px;
  overflow: hidden;
}

.pose3d-web-viewer__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #aaa;
}

.pose3d-web-viewer__toggles {
  display: flex;
  gap: 16px;
  align-items: center;
  margin: 10px 0 6px;
  font-size: 13px;
}

.pose3d-web-viewer__job {
  margin-left: auto;
  opacity: 0.6;
  font-family: ui-monospace, monospace;
  font-size: 11px;
}

.pose3d-playback-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.pose3d-playback-bar button {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  padding: 6px 10px;
  background: #f4f4f5;
  cursor: pointer;
}

.pose3d-playback-bar__active {
  background: #0a84ff !important;
  color: #fff;
  border-color: #0a84ff !important;
}

.pose3d-playback-bar input[type="range"] {
  flex: 1 1;
  min-width: 120px;
}

.pose3d-playback-bar__time {
  font-size: 12px;
  opacity: 0.75;
  min-width: 110px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pose3d/pose3d.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mEAAmE;EACnE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".pose3d-media-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: rgba(10, 132, 255, 0.08);\n  border: 1px solid rgba(10, 132, 255, 0.25);\n}\n\n.pose3d-media-toolbar__btn {\n  border: none;\n  border-radius: 6px;\n  padding: 8px 14px;\n  font-weight: 600;\n  cursor: pointer;\n  background: #0a84ff;\n  color: #fff;\n}\n\n.pose3d-media-toolbar__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pose3d-media-toolbar__btn--secondary {\n  background: transparent;\n  color: #0a84ff;\n  border: 1px solid rgba(10, 132, 255, 0.45);\n}\n\n.player-exercise-details__eval-video-card--pose3d-selected {\n  outline: 2px solid #0a84ff;\n  outline-offset: 1px;\n}\n\n.player-exercise-details__move-video-icon-btn--active {\n  background: rgba(10, 132, 255, 0.18) !important;\n  color: #0a84ff;\n}\n\n.pose3d-setup {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-height: 420px;\n}\n\n.pose3d-setup__cams {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n@media (max-width: 900px) {\n  .pose3d-setup__cams {\n    grid-template-columns: 1fr;\n  }\n}\n\n.pose3d-setup__cam {\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  padding: 8px;\n  background: #0f1114;\n  color: #fff;\n}\n\n.pose3d-setup__cam h4 {\n  margin: 0 0 8px;\n  font-size: 14px;\n}\n\n.pose3d-setup__video-wrap {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  background: #000;\n  overflow: hidden;\n  border-radius: 4px;\n  touch-action: none;\n}\n\n.pose3d-setup__video-wrap video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.pose3d-setup__overlay {\n  /* Position/size set in JS to match object-fit:contain letterbox. */\n  position: absolute;\n  cursor: crosshair;\n  z-index: 2;\n  touch-action: none;\n}\n\n.pose3d-setup__controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin-top: 8px;\n  font-size: 13px;\n}\n\n.pose3d-setup__controls input[type=\"number\"] {\n  width: 72px;\n}\n\n.pose3d-setup__shared {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  padding: 8px 0;\n}\n\n.pose3d-setup__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.pose3d-setup__status {\n  font-size: 13px;\n  opacity: 0.85;\n}\n\n.pose3d-setup__error {\n  color: #ff6b6b;\n  font-size: 13px;\n}\n\n.pose3d-web-viewer__canvas {\n  width: 100%;\n  height: min(56vh, 480px);\n  background: #111;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.pose3d-web-viewer__empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #aaa;\n}\n\n.pose3d-web-viewer__toggles {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin: 10px 0 6px;\n  font-size: 13px;\n}\n\n.pose3d-web-viewer__job {\n  margin-left: auto;\n  opacity: 0.6;\n  font-family: ui-monospace, monospace;\n  font-size: 11px;\n}\n\n.pose3d-playback-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.pose3d-playback-bar button {\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  padding: 6px 10px;\n  background: #f4f4f5;\n  cursor: pointer;\n}\n\n.pose3d-playback-bar__active {\n  background: #0a84ff !important;\n  color: #fff;\n  border-color: #0a84ff !important;\n}\n\n.pose3d-playback-bar input[type=\"range\"] {\n  flex: 1;\n  min-width: 120px;\n}\n\n.pose3d-playback-bar__time {\n  font-size: 12px;\n  opacity: 0.75;\n  min-width: 110px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
